import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Linkedin } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HomePage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-217">
      {/* Navigation */}
      <nav className="border-b border-gray-100 bg-white/80 backdrop-blur-md sticky top-0 z-50" data-id="element-218">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-219">
          <span className="text-xl font-bold text-gray-900" data-id="element-220">
            Vivin Varghese
          </span>
          <div className="flex items-center gap-6" data-id="element-221">
            <Link to="/" className="text-sm font-medium text-gray-900" data-id="element-222">
              Home
            </Link>
            <Link to="/contact" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-223">
              Contact
            </Link>
            <div className="h-4 w-px bg-gray-200 hidden sm:block" data-id="element-224"></div>
            <div className="flex items-center gap-3" data-id="element-225">
              <a href="https://www.linkedin.com/in/14vivin/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-600 transition-colors hidden sm:block" data-id="element-226">
                <Linkedin className="w-5 h-5" data-id="element-227" />
              </a>
              <Link to="/book" data-id="element-228">
                <Button size="sm" data-id="element-229">Book Meeting</Button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <main className="flex-grow" data-id="element-230">
        <section className="relative py-20 lg:py-28 overflow-hidden" data-id="element-231">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white -z-10" data-id="element-232" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
            <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-234">
              {/* Profile Image */}
              <div className="flex-shrink-0" data-id="element-235">
                <img src="https://cdn.magicpatterns.com/uploads/uRFm4TqjemDmkSdPVLEX96/pasted-image.jpg" alt="Vivin Varghese" className="w-48 h-48 md:w-64 md:h-64 rounded-full object-cover shadow-2xl border-4 border-white" data-id="element-236" />
              </div>

              {/* Hero Content */}
              <div className="flex-grow text-center md:text-left" data-id="element-237">
                <h1 className="text-4xl md:text-6xl font-bold text-gray-900 tracking-tight mb-8" data-id="element-238">
                  Vivin Varghese
                </h1>
                <div className="flex flex-col sm:flex-row items-center md:items-start gap-4" data-id="element-239">
                  <Link to="/book" data-id="element-240">
                    <Button size="lg" className="min-w-[200px] shadow-lg shadow-blue-100" data-id="element-241">
                      Schedule a Meeting
                      <ArrowRight className="ml-2 w-5 h-5" data-id="element-242" />
                    </Button>
                  </Link>
                  <Link to="/contact" data-id="element-243">
                    <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-244">
                      Get in Touch
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20 bg-white border-t border-gray-100" data-id="element-245">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-247">
              About Me
            </h2>
            <div className="prose prose-lg text-gray-600 mx-auto leading-relaxed space-y-6" data-id="element-248">
              <p data-id="element-249">
                I am part of the{' '}
                <strong data-id="element-250">
                  Edge and Interconnection team at CtrlS Datacenters
                </strong>
                , where I bring over a decade's experience in the
                Interconnection, Peering, Cloud, and Data Center industry.
                Throughout my career, I have worked in strategic roles at
                various organizations including <strong data-id="element-251">DE-CIX India</strong>,{' '}
                <strong data-id="element-252">Mumbai CH</strong>,<strong data-id="element-253">Web Werks</strong>, and{' '}
                <strong data-id="element-254">CtrlS Datacenters</strong>.
              </p>
              <p data-id="element-255">
                I leverage this deep technical background as an{' '}
                <strong data-id="element-256">AI Thought Leader</strong>, advocating for the robust
                edge and interconnection infrastructure required to power the
                next generation of Artificial Intelligence. My focus is on
                building scalable, resilient infrastructure that enables AI
                innovation and digital transformation.
              </p>
              <p data-id="element-257">
                I will be attending the{' '}
                <strong data-id="element-258">PTC Event in Hawaii (January 18-21, 2026)</strong> and
                would love to connect with fellow industry leaders, innovators,
                and partners. If you're attending, let's schedule a time to meet
                and discuss how we can collaborate on the future of edge
                infrastructure and AI.
              </p>
            </div>
            <div className="mt-10 text-center" data-id="element-259">
              <a href="https://www.linkedin.com/in/14vivin/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 font-medium hover:text-blue-700 hover:underline" data-id="element-260">
                linkedin.com/in/14vivin <ArrowRight className="ml-1 w-4 h-4" data-id="element-261" />
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 py-12" data-id="element-262">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-6" data-id="element-263">
          <div className="flex items-center gap-6" data-id="element-264">
            <Link to="/" className="text-gray-500 hover:text-gray-900 transition-colors" data-id="element-265">
              Home
            </Link>
            <Link to="/contact" className="text-gray-500 hover:text-gray-900 transition-colors" data-id="element-266">
              Contact
            </Link>
            <Link to="/book" className="text-gray-500 hover:text-gray-900 transition-colors" data-id="element-267">
              Book Meeting
            </Link>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-268">
            © {new Date().getFullYear()} Vivin Varghese. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}